(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
 
    connectedCallback() {

      
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

       const _this = this;

         window.addEventListener("resize", debounce(function(e) {
             _this.setHeaderHeight();
         },150));
      
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      const megamenu_childlink_sliderArr = this.querySelectorAll('.megamenu-childlink_slider'); 
      const mega_menu__slidesArr = this.querySelectorAll('.mega-menu__slide_blocks_wrapper');
    
      if(mega_menu__slidesArr.length) {
        for(const mega_menu__slider of mega_menu__slidesArr) {
          const mega_menu__slide_blocksArr = mega_menu__slider.querySelectorAll('.mega-menu__slide_block');
          if(mega_menu__slide_blocksArr.length > 4) {
                  const slider_autoplay = mega_menu__slider.getAttribute('data-autoplay_slider') || false;


                let options = {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                arrows: true, 
                autoplay: slider_autoplay,
                nextArrow: '<button class="slick-next  slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="31" viewBox="0 0 17 31" fill="none"><path d="M1.5 29L14.2929 16.2071C14.6834 15.8166 14.6834 15.1834 14.2929 14.7929L1.5 2" stroke="white" stroke-width="3" stroke-linecap="round"/></svg></button>',
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="31" viewBox="0 0 17 31" fill="none"><path d="M15.5 2L2.70711 14.7929C2.31658 15.1834 2.31658 15.8166 2.70711 16.2071L15.5 29" stroke="white" stroke-width="3" stroke-linecap="round"/></svg></button>',
                responsive: [{
                  breakpoint: 1500,
                  settings: { 
                    slidesToShow: 3
                  }
              }]
              };

            mega_menu__slider.classList.add('enable_slider');
            $(mega_menu__slider).slick(options);
           
          }
        }
      }
      if(megamenu_childlink_sliderArr.length) {
        for(const megamenu_childlink_slider of megamenu_childlink_sliderArr) {
          const megamenu_childlink_sliderBlocksArr = megamenu_childlink_slider.querySelectorAll('.mega-menu__slide_block');
          if(megamenu_childlink_sliderBlocksArr.length > 4) {
 
                let options = {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                arrows: true, 
                autoplay:false,
                nextArrow: '<button class="slick-next  slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="31" viewBox="0 0 17 31" fill="none"><path d="M1.5 29L14.2929 16.2071C14.6834 15.8166 14.6834 15.1834 14.2929 14.7929L1.5 2" stroke="white" stroke-width="3" stroke-linecap="round"/></svg></button>',
                prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="31" viewBox="0 0 17 31" fill="none"><path d="M15.5 2L2.70711 14.7929C2.31658 15.1834 2.31658 15.8166 2.70711 16.2071L15.5 29" stroke="white" stroke-width="3" stroke-linecap="round"/></svg></button>',
                    responsive: [{
                  breakpoint: 1500,
                  settings: { 
                    slidesToShow: 3
                  }
              }]
              };
            megamenu_childlink_slider.classList.add('enable_slider');
            $(megamenu_childlink_slider).slick(options);
          }
        }
      }

      if (!this.headerIsAlwaysSticky) {
             const headerTopOffset = $('.section-header').offset().top;
             const announcementBarHeight = $('.announcement-bar').height() || 0;

             if(headerTopOffset > announcementBarHeight) {
                this.header.classList.add('shopify-section-header-sticky');
                 document.body.classList.add('active-header-sticky');
            this.header.classList.remove('shopify-section-header-hidden');
             }
        };

      this.mega_menusArr = this.querySelectorAll('.header__inline-menu .mega-menu');
      if(this.mega_menusArr.length) {
        for(const mega_menu of this.mega_menusArr) {
           mega_menu.addEventListener('mouseenter', function(e) {
          document.body.classList.add('megamenu-active');
        });
        mega_menu.addEventListener('mouseleave', function(e) {
          document.body.classList.remove('megamenu-active');
        });
        }
      }
 

      this.grandchild_mega_menu_links = this.querySelectorAll('.grandchild-mega_menu_link');
      if(this.grandchild_mega_menu_links.length) {
        for(const grandchild_mega_menu_link of this.grandchild_mega_menu_links) {

          const grandchild_mega_menu_link__handle = grandchild_mega_menu_link.getAttribute('data-handle');
          const parentMenuEl = grandchild_mega_menu_link.closest('.mega-menu__content');
          const megamenu_childlink_slider = parentMenuEl.querySelector(`.megamenu-childlink_slider[data-handle="${grandchild_mega_menu_link__handle}"]`);

                grandchild_mega_menu_link.addEventListener('mouseenter', function(e) {

                 
                  const prev_active_megamenu_childlink_slider = parentMenuEl.querySelector('.mega-menu__content .megamenu-childlink_slider.active');
                  const prev_active_link = parentMenuEl.querySelector('.active_slider_link');
                  if(prev_active_link) {
                   prev_active_link.classList.remove('active_slider_link');
                  }
                  if(prev_active_megamenu_childlink_slider) {
                    const prev_active_megamenu_childlink_slider__Handle = prev_active_megamenu_childlink_slider.getAttribute('data-handle');
                    if(prev_active_megamenu_childlink_slider__Handle != grandchild_mega_menu_link__handle) {
                      prev_active_megamenu_childlink_slider.classList.remove('active');
                    }
                  }
                if(megamenu_childlink_slider) {
              
                  this.classList.add('active_slider_link');
                  megamenu_childlink_slider.classList.add('active');
                  parentMenuEl.classList.add('active_grandchild_slider');
                } else {
                   parentMenuEl.classList.remove('active_grandchild_slider');
                }
              });
        
       
        }
      }

          const header_menu_nav_arr = this.querySelectorAll('header-menu .mega-menu');

  header_menu_nav_arr.forEach(item => {
  const dropdown = item.querySelector('.mega-menu__content');

  hoverIntent(item, {
    over() {
      item.classList.add('open');
    },
    out() {
      item.classList.remove('open');
    },
    sensitivity: 7,
    interval: 100,
    timeout: 200
  });

  if (dropdown) {
    dropdown.addEventListener("mouseenter", () => {
      item.classList.add("open");
    });
    dropdown.addEventListener("mouseleave", () => {
      item.classList.remove("open");
    });
  }
});
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
     
    
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      let headerBounds_bottom = this.headerBounds.bottom;
      if(document.querySelector('.announcement-bar-timer-section')) {
       headerBounds_bottom = 1;
      }
      
      if (scrollTop > this.currentScrollTop && scrollTop > headerBounds_bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBounds_bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('active-header-sticky');
      this.closeMenuDisclosure(); 
      this.closeSearchModal();
    }

    reveal() {
     
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      document.body.classList.add('active-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
     
      if (this.headerIsAlwaysSticky) return;
      document.body.classList.remove('active-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
